<template>
  <header class="site-header" :class="{ 'is-scrolled': scrolled }">
    <div class="container header-inner">
      <a class="brand" href="#top" @click.prevent="goTo('top')">
        <img src="@/assets/img/logo.png" alt="达人连连" class="brand-logo" />
      </a>

      <nav class="nav" :class="{ 'is-open': menuOpen }">
        <a
          v-for="item in navItems"
          :key="item.id"
          class="nav-link"
          :class="{ 'is-active': active === item.id }"
          :href="'#' + item.id"
          @click.prevent="goTo(item.id)"
        >{{ item.label }}</a>
      </nav>

      <div class="header-actions">
        <div
          class="dl"
          @mouseenter="open = true"
          @mouseleave="open = false"
        >
          <button class="btn btn--dark dl-trigger" @click="open = !open" :aria-expanded="open">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3v12" /><path d="m7 11 5 5 5-5" /><path d="M5 21h14" />
            </svg>
            下载达人连连
            <svg class="chev" :class="{ 'is-up': open }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <transition name="drop">
            <div v-show="open" class="dl-menu">
              <button class="dl-item" @click="download('normal')">
                <span class="dl-item-name">会员版下载</span>
                <span class="dl-item-desc">登录并购买会员使用</span>
              </button>
              <button class="dl-item" @click="download('kami')">
                <span class="dl-item-name">卡密版下载</span>
                <span class="dl-item-desc">使用卡密授权激活</span>
              </button>
            </div>
          </transition>
        </div>

        <button class="burger" :class="{ 'is-open': menuOpen }" @click="menuOpen = !menuOpen" aria-label="菜单">
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { downloadLatestApp } from "@/utils/download";

export default {
  name: "AppHeader",
  data() {
    return {
      scrolled: false,
      open: false,
      menuOpen: false,
      active: "top",
      navItems: [
        { id: "features", label: "产品功能" },
        { id: "agent", label: "诚招代理" },
        { id: "contact", label: "联系我们" }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 8;
      const probe = window.scrollY + window.innerHeight * 0.35;
      let current = "top";
      for (const item of this.navItems) {
        const el = document.getElementById(item.id);
        if (el && el.offsetTop <= probe) current = item.id;
      }
      this.active = current;
    },
    goTo(id) {
      this.menuOpen = false;
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    },
    download(type) {
      this.open = false;
      this.menuOpen = false;
      downloadLatestApp(type);
    }
  }
};
</script>

<style scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 1000;
  height: var(--header-h);
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: saturate(180%) blur(16px);
  -webkit-backdrop-filter: saturate(180%) blur(16px);
  border-bottom: 1px solid transparent;
  transition: border-color 0.25s ease, background 0.25s ease;
}

.site-header.is-scrolled {
  background: rgba(255, 255, 255, 0.88);
  border-bottom-color: var(--border);
}

.header-inner {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.brand-logo {
  height: 34px;
  width: auto;
}

.nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 12px;
}

.nav-link {
  position: relative;
  padding: 8px 14px;
  border-radius: var(--r-sm);
  color: var(--text-2);
  font-size: 15px;
  font-weight: 500;
  transition: color 0.18s ease, background 0.18s ease;
}

.nav-link:hover {
  color: var(--text-1);
  background: rgba(17, 24, 39, 0.04);
}

.nav-link.is-active {
  color: var(--text-1);
  font-weight: 600;
}

.header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ---------- 下载按钮 + 下拉 ---------- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--r-full);
  font-weight: 600;
  white-space: nowrap;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease,
    border-color 0.18s ease, color 0.18s ease;
}

.btn--dark {
  background: var(--ink);
  color: #fff;
  box-shadow: var(--shadow-sm);
}

.btn--dark:hover {
  background: #000;
  box-shadow: 0 8px 22px rgba(17, 24, 39, 0.22);
  transform: translateY(-1px);
}

.dl {
  position: relative;
}

.dl-trigger {
  height: 42px;
  padding: 0 18px;
  font-size: 14.5px;
}

.ico {
  width: 17px;
  height: 17px;
}

.chev {
  width: 14px;
  height: 14px;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.chev.is-up {
  transform: rotate(180deg);
}

.dl-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 240px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
}

.dl-menu::before {
  content: "";
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  height: 12px;
}

.dl-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 11px 14px;
  border-radius: var(--r-md);
  text-align: left;
  transition: background 0.16s ease;
}

.dl-item:hover {
  background: var(--bg-soft);
}

.dl-item-name {
  color: var(--text-1);
  font-size: 14.5px;
  font-weight: 600;
}

.dl-item-desc {
  color: var(--text-3);
  font-size: 12.5px;
}

.drop-enter-active,
.drop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.drop-enter-from,
.drop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ---------- 汉堡 ---------- */
.burger {
  display: none;
  width: 42px;
  height: 42px;
  border-radius: var(--r-sm);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.burger span {
  display: block;
  width: 18px;
  height: 2px;
  border-radius: 2px;
  background: var(--text-1);
  transition: transform 0.22s ease, opacity 0.22s ease;
}

.burger.is-open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.burger.is-open span:nth-child(2) {
  opacity: 0;
}
.burger.is-open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

@media (max-width: 860px) {
  .burger {
    display: flex;
  }

  .nav {
    position: absolute;
    top: calc(100% + 1px);
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
    margin: 0;
    padding: 10px 16px 16px;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid var(--border);
    box-shadow: var(--shadow-md);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-8px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  }

  .nav.is-open {
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  .nav-link {
    padding: 12px 14px;
    font-size: 16px;
  }
}

@media (max-width: 520px) {
  .brand-logo {
    height: 28px;
  }
  .dl-trigger {
    height: 38px;
    padding: 0 14px;
    font-size: 13.5px;
  }
  .dl-trigger .ico {
    display: none;
  }
  .dl-menu {
    width: 210px;
  }
}
</style>
